import { GiHumanPyramid } from "react-icons/gi";
import { GoCalendar } from "react-icons/go";
import { IoDocumentTextOutline, IoCogOutline } from "react-icons/io5";
import { MdCrisisAlert } from "react-icons/md";
import { SiCivicrm } from "react-icons/si";

const sidebar = [
  { 
    titleKey: "nav.home",
    title: "Home",
    icon: <SiCivicrm />,
    link: '/hr/home' 
  },
  { 
    titleKey: "sidebar.employees",
    title: "Employees",
    icon: <MdCrisisAlert />,
    link: '/hr/employees'
  },
  { 
    titleKey: "sidebar.documents",
    title: "Documents",
    icon: <IoDocumentTextOutline />,
    link: '/hr/documents'
  },
  { 
    titleKey: "sidebar.attendance",
    title: "Attendance",
    icon: <GiHumanPyramid />,
    link: '/hr/attendance'
  },
  { 
    titleKey: "sidebar.leaveRequests",
    title: "Leave Requests",
    icon: <GiHumanPyramid />,
    link: '/hr/leave-requests'
  },
  { 
    titleKey: "sidebar.payroll",
    title: "Payroll",
    icon: <GoCalendar />,
    link: '/hr/payroll'
  },
  {
    titleKey: "settings.title",
    title: "Settings",
    icon: <IoCogOutline />,
    link: '/hr/settings',
    fixedBottom: true
  }
];

export default sidebar;
